import z from "zod";

// TODO: Add actual error types for Ably external service
const ablyErrorTypeValues = ["PLACEHOLDER_ERROR"] as const;

const ablyErrorTypeSchema = z.enum(ablyErrorTypeValues);
const AblyErrorType = ablyErrorTypeSchema.enum;
type AblyErrorType = z.infer<typeof ablyErrorTypeSchema>;

type ErrorDetails = {
  sentryDescription: string;
};

export type AblyErrors = {
  errorType: typeof AblyErrorType.PLACEHOLDER_ERROR;
  // TODO: Add specific data fields for Ably errors
  data: Record<string, never>;
};

export const ablyErrorDetails: Record<AblyErrorType, ErrorDetails> = {
  [AblyErrorType.PLACEHOLDER_ERROR]: {
    sentryDescription: "Ably external service error",
  },
};
